import { GLOBAL_LOADER_STEP } from '@client/enums';

import { accessingCampaignEditor, editMenuOptions } from './accessing-campaign-editor';
import { adDetails, campaignDetails, targetingDetails } from './details';
import { editingCampaign } from './editing-campaign';
import { insightsSection } from './insights';
import {
  metricsClicks,
  metricsCTR,
  metricsCTRR,
  metricsDeliveries,
  metricsGranularity,
  metricsImpressions,
  metricsReach,
  metricsWrapper
} from './metrics';
import { saveCampaign } from './save';

let editSteps = [
  editingCampaign,
  accessingCampaignEditor,
  editMenuOptions,
  GLOBAL_LOADER_STEP,
  metricsWrapper,
  metricsGranularity,
  metricsDeliveries,
  metricsImpressions,
  metricsClicks,
  metricsReach,
  metricsCTR,
  metricsCTRR,
  campaignDetails,
  adDetails,
  targetingDetails,
  insightsSection,
  saveCampaign
];

editSteps[3] = {
  ...editSteps[3],
  popover: {
    ...editSteps[3].popover,
    title: 'Loading campaign...'
  }
};

export const EDIT_STEPS = editSteps;
